// Categorie del sito, allineate alle playlist del canale YouTube.
export const CATEGORIES = [
  "Esteri",
  "Europa",
  "Italia",
  "Discorsi storici",
  "Video brevi",
];
